export const UPDATE_TASK_LIST = "UPDATE_TASK_LIST";
export const SET_TASK_LIST_LOADING = "SET_TASK_LIST_LOADING";
export const SET_TASK_ITEM_LOADING = "SET_TASK_ITEM_LOADING";
export const SET_TASK_ITEM_STATUS = "SET_TASK_ITEM_STATUS";
